import React from 'react';
import classes from "./style.module.scss";
import { Images } from '../../../../assets';

const ProductDisplay = ({ productImage }) => {
    return (
        <div className={`${classes.productCardWrapper} mb-4`}>
            <div className={`${classes.detailsWrapper}`}>
                <div className='flex items-center mb-3'>
                    <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20`}>
                        Images
                    </div>
                </div>
                <div className={`${classes.displayProductWrapper}`}>
                    {productImage[0]?.value?.length >0 ? productImage[0]?.value?.map((it, index) => (
                        <div key={index} className={classes.productLogoWrap}>
                            <img src={it} alt='Product' />
                        </div>
                    )) : <img src={Images.noImage}  /> }
                </div>
            </div>
        </div>
    );
}

export default ProductDisplay;
